import React, { useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../store";
import EVENT_QUERY from '../events/queries/EVENT_QUERY';
import Query from "../common/Query";
import Loading from "../common/Loading";
import JoinCTA from "../common/JoinCTA";
import EventDetail from "../events/interfaces/EventDetail";
import { Alert, Button } from "react-bootstrap";
const MailPullStatus = () => {
  function useQueryParams() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQueryParams();
  const navigate = useNavigate();
  let { eventId }: { eventId?: string } = useParams();
  let status = query.get("status");
  let error = query.get("error");
  const { state } = useContext(AppContext);
  const isVolunteer = state.orgInfo?.volunteer_access;
  const isEC = state.orgInfo?.event_coordinator;
  const isFS = state.orgInfo?.field_support;
  const loading = state.orgInfo?.loading;
  if (isVolunteer || isEC || isFS) {
    return <>
      <Query variables={{ eventId }} query={EVENT_QUERY}>{({ data: { event } }: { data: { event: EventDetail } }) => {
        if (!event) {
          return <span>Not Found.</span>;
        } else {
          return <>
            <Alert variant={error ? "danger" : "success"}>{status}</Alert>
            <Button onClick={() => navigate(`/event/mail-pull/${eventId}`)}>Request Another Report</Button>
          </>

        }
      }}
      </Query>
    </>;
  } else {
    if (loading) {
      return <Loading />;
    } else {
      return <JoinCTA />;
    }
  }
};

export default MailPullStatus;